import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=04e028a0&scoped=true"
import script from "./QA.vue?vue&type=script&lang=ts"
export * from "./QA.vue?vue&type=script&lang=ts"
import style0 from "./QA.vue?vue&type=style&index=0&id=04e028a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e028a0",
  null
  
)

export default component.exports